import type { Customer } from '@metron/shared';

/**
 * The three mutually-exclusive customer categories surfaced in the UI.
 * Derived from Customer.accountType + Customer.realEstateAccountType.
 * The backend schema (accountTypeSchema / realEstateAccountTypeSchema)
 * enforces that Real Estate customers always have a realEstateAccountType,
 * but the frontend Customer type leaves realEstateAccountType optional,
 * so the helper returns null when that invariant is violated — surfacing
 * the data issue in the UI rather than silently defaulting.
 */
export type CustomerTypeCategory = 'Utility' | 'CMFI' | 'MHP';

export const CUSTOMER_TYPE_CATEGORIES: readonly CustomerTypeCategory[] = [
  'Utility',
  'CMFI',
  'MHP',
] as const;

export function getCustomerTypeCategory(
  customer: Pick<Customer, 'accountType' | 'realEstateAccountType'>,
): CustomerTypeCategory | null {
  if (customer.accountType === 'Utility') return 'Utility';
  if (customer.accountType === 'Real Estate') {
    if (customer.realEstateAccountType === 'CMFI') return 'CMFI';
    if (customer.realEstateAccountType === 'MHP') return 'MHP';
  }
  return null;
}
